import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';
import { Buttons, FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { openLinkInNewTab } from 'Utils/links';
import { PAYMENT_INFO_URL } from 'Constants/helpsUrl';
import { SpeiOutResponse } from 'Types/common';
import * as Styled from './styles';

const SpeiOutInfo = ({ info }: { info: SpeiOutResponse }): JSX.Element => {
  const { t } = useTranslation(locizeNS.DASHBOARD);

  return (
    <Styled.SpeiOutContainer
      direction="column"
      fullHeight
      fullWidth
      gap="dimension_08"
      align="center"
    >
      <Text type="headline" size="XS_L_S" color="dark">
        {t('SpeiOutInfo.title')}
      </Text>
      <Text type="paragraphs" size="M_M_S" color="dark">
        {t('SpeiOutInfo.subtitle')}
      </Text>
      <FlexContainer direction="column" align="center" gap="dimension_08">
        <Text type="paragraphs" size="S_M_S" color="grey">
          {t('SpeiOutInfo.amount', {
            amount: YayoyakiFormatter.formatAmountMxn(info.amountDecimal),
          })}
        </Text>
        <Text type="paragraphs" size="S_M_S" color="grey">
          {t('SpeiOutInfo.date', { date: new Date(info.created).toLocaleDateString('es-ES') })}
        </Text>
        <Text type="paragraphs" size="S_M_S" color="grey">
          {t('SpeiOutInfo.concept', { concept: info?.concept })}
        </Text>
        <Text type="paragraphs" size="S_M_S" color="grey">
          {t('SpeiOutInfo.cve.track', { track: info?.trackId })}
        </Text>
      </FlexContainer>
      <Buttons.Classic
        label={t('SpeiOutInfo.button')}
        mode="primary"
        size="m"
        onClick={() => openLinkInNewTab(PAYMENT_INFO_URL)}
      />
    </Styled.SpeiOutContainer>
  );
};

export default SpeiOutInfo;
